import Head from 'next/head';
import { ThemePage } from '@/components/themes/ThemePage';
import { ThemeInitiatives } from '@/components/themes/ThemeInitiatives';
import { ThemeEntities } from '@/components/themes/ThemeEmtities';

const GOODIE_BAG_SUB_CATEGORIES = [
  {
    title: 'Event Goodie Bags',
    description:
      'Branded product packs for conferences, expos, and industry events that attendees actually want to take home.',
  },
  {
    title: 'Welcome Kits',
    description:
      'New employee onboarding packs, membership welcome boxes, and first-day surprises filled with great products.',
  },
  {
    title: 'Race & Sports Packs',
    description:
      'Recovery snacks, hydration, and energy products for marathon runners, sports teams, and fitness events.',
  },
  {
    title: 'Festival & Concert Bags',
    description:
      'Fun, shareable product packs for music festivals, outdoor events, and community gatherings.',
  },
  {
    title: 'Corporate Gifting',
    description:
      'Premium curated boxes for client appreciation, end-of-year gifts, and milestone celebrations.',
  },
  {
    title: 'Subscription & Sample Boxes',
    description:
      'Discovery packs that introduce consumers to new brands through curated monthly or one-off sample boxes.',
  },
];

export default function GoodieBagsThemePage() {
  return (
    <>
      <Head>
        <title>Goodie Bags | Sizzle</title>
        <meta
          name="description"
          content="Curated product packs for events, conferences, welcome kits, and giveaways. Connect with brands looking to get their products into goodie bags."
        />
      </Head>
      <ThemePage
        breadcrumbs={[{ label: 'Themes', href: '/themes' }, { label: 'Goodie Bags' }]}
        title="Goodie Bags & curated packs"
        description="Connect with brands looking to get their products into goodie bags, welcome kits, event packs, and curated boxes. Perfect for event organisers, HR teams, and community groups."
        heroImage=""
        subCategoriesTitle="Every occasion deserves a great goodie bag"
        subCategoriesSubtitle="From conferences to fun runs, welcome kits to festival packs — find brands eager to fill your next goodie bag."
        subCategories={GOODIE_BAG_SUB_CATEGORIES}
      >
        <ThemeInitiatives
          title="Featured Initiatives"
          subtitle="Initiatives needing goodie bags or some goodie bag connection."
          categories={['trade']}
          limit={6}
          themes={['goodie-bags']}
        />

        <ThemeEntities
          title="Featured Brands and Businesses"
          roles={['brand', 'supplier']}
          subtitle="Brands and businesses who help fill goodie bags or some other connection"
          limit={8}
          themes={['goodie-bags']}
        />
      </ThemePage>
    </>
  );
}
